export class DownloadHelper {
  static open(url: string) {
    /* if (a5.cl.Instance().DOM().clientEnvironment() == "DESKTOP") {
            var elem = document.createElement('iframe');
            elem.src = url;
            elem.style.display = 'none';
            var body = document.getElementsByTagName('body')[0];
            elem.onload = function(){
                setTimeout(function(){
                    body.removeChild(elem);
                }, 1000);
            };
            body.appendChild(elem);
        } else {*/
    window.open(url);
    // }
  }
}
